import type { FC } from "react";
import cn from "classnames";
import styles from "@/layout/agentChat/agentChatDrawer.module.scss";
import IconButton from "@mui/material/IconButton";
import { SparkleIcon } from "@phosphor-icons/react/Sparkle";
import { useTranslation } from "react-i18next";

const AgentLoader: FC = () => {
  const { t } = useTranslation("translation", { keyPrefix: "agentChat" });

  return (
    <div className={cn(styles.messageRow, styles.responseRow)}>
      <div className={cn(styles.messageBubble, styles.responseBubble, styles.loaderBubble)}>
        <div className={styles.messageLabel}>
          <IconButton className={cn(styles.messageLabelIcon, styles.loaderIcon)}>
            <SparkleIcon size={14} />
          </IconButton>
          <span>{t("agentLabel")}</span>
        </div>
        <div className={styles.thinkingDots} aria-label={t("loading")}>
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
        </div>
      </div>
    </div>
  );
};

export default AgentLoader;
